function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 32C19.9041 32 17.8775 31.1349 16.3706 29.5677C14.8612 27.9979 14 25.8526 14 23.6C14 22.5731 14.2215 21.5759 14.6245 20.5836L13.1105 19.0696C12.4268 20.483 12 21.9841 12 23.6C12 26.3583 13.0536 29.0035 14.9289 30.9539C16.8043 32.9043 19.3478 34 22 34C23.684 34 25.3242 33.5583 26.7773 32.7365L25.295 31.2541C24.266 31.7425 23.1433 32 22 32ZM29.9463 24.5724L31.6606 26.2867C31.884 25.4177 32 24.5151 32 23.6C32 19.1935 28.8247 15.6401 25.9193 12.3887L25.6338 12.069L24.2376 10.5056C23.0448 9.16999 20.9552 9.16999 19.7624 10.5056L18.3663 12.069L18.0834 12.3856C18.0325 12.4425 17.9815 12.4995 17.9305 12.5566L19.3471 13.9732C19.4324 13.8776 19.5179 13.7819 19.6037 13.6858L19.858 13.4012L19.8583 13.4008L21.2541 11.8378C21.6517 11.3926 22.3483 11.3926 22.7459 11.8378L24.1414 13.4005L24.1418 13.4009L24.142 13.4012L24.399 13.689C25.831 15.2923 27.199 16.8238 28.2516 18.4612C29.3503 20.1703 30 21.8419 30 23.6C30 23.9269 29.9819 24.2514 29.9463 24.5724Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 21.2195,
  transform: "matrix(-0.707107 0.707107 0.707107 0.707107 15.6963 14.5752)",
  fill: "currentColor"
});

var SvgRemoveWatermark = function SvgRemoveWatermark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemoveWatermark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove-watermark.71447a4e.svg";
export { ForwardRef as ReactComponent };